// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3WYjz","title":"Header_title__3Ls98","left":"Header_left__3Kgg7","clinicName":"Header_clinicName__1I_qt"};